export * from './event-item/event-item.component';
export * from './event-list/event-list.component';



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/events/index.ts